import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class FormsService {
  constructor(private http: HttpClient) {}

  public fetchForms(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/forms`
    return this.http.post(url, params)
  }
  public fetchForm(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/form/${id}`
    return this.http.get(url, {})
  }

  public deleteForm(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/form/${id}`
    return this.http.delete(url)
  }

  public createForm(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/form`
    return this.http.post(url, params)
  }

  public updateForm(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/form/${id}`
    return this.http.put(url, params)
  }
}
